import { render, staticRenderFns } from "./transporterProfileform.vue?vue&type=template&id=72b357ce&scoped=true&"
import script from "./transporterProfileform.vue?vue&type=script&lang=js&"
export * from "./transporterProfileform.vue?vue&type=script&lang=js&"
import style0 from "./transporterProfileform.vue?vue&type=style&index=0&id=72b357ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b357ce",
  null
  
)

export default component.exports